// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__1Qh8U","Icon":"Languages_Icon__23cR8","LanguagesSelect":"Languages_LanguagesSelect__1Jbt8","minimalist":"Languages_minimalist__1Tiaf"};